import classes from './QualityScoreCell.module.scss';

export const QualityScoreCell = ({ value }: { value: number }) => {
    const colorClass = value >= 80 ? 'green' : value < 50 ? 'red' : 'orange';
    return <div className={`${classes.qualityScoreCell} ${classes[colorClass]}`}>{value}</div>;
};
